import React, { useState } from 'react';
import { Shield, AlertCircle, Info, X } from 'lucide-react';
import { hygienInfo } from '../mock';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Button } from './ui/button';

const HygieneInfo = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Sticky Info Banner */}
      <div className="bg-gradient-to-r from-green-600 to-blue-600 text-white py-3 sticky top-20 z-40 shadow-lg">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <Shield className="h-6 w-6 flex-shrink-0" />
              <p className="text-sm sm:text-base font-medium">
                Professionelle Desinfektion · Sicherer Transport · Auch für infektiöse Tiere
              </p>
            </div>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setIsOpen(true)}
              className="text-white hover:bg-white/20 flex-shrink-0"
            >
              <Info className="h-4 w-4 mr-1" />
              Mehr erfahren
            </Button>
          </div>
        </div>
      </div>

      {/* Modal/Dialog */}
      {isOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50" onClick={() => setIsOpen(false)}>
          <div className="max-w-3xl w-full" onClick={(e) => e.stopPropagation()}>
            <Card className="shadow-2xl border-2 border-green-300">
              <CardHeader className="bg-gradient-to-r from-green-600 to-blue-600 text-white relative">
                <button
                  onClick={() => setIsOpen(false)}
                  className="absolute top-4 right-4 text-white hover:bg-white/20 rounded-full p-2 transition-colors"
                >
                  <X className="h-5 w-5" />
                </button>
                <div className="flex items-center space-x-3">
                  <Shield className="h-8 w-8" />
                  <CardTitle className="text-2xl">{hygienInfo.title}</CardTitle>
                </div>
              </CardHeader>
              <CardContent className="p-6 space-y-6">
                {/* Regular Disinfection */}
                <div className="bg-green-50 border-2 border-green-200 rounded-xl p-6">
                  <div className="flex items-start space-x-3">
                    <Shield className="h-6 w-6 text-green-600 flex-shrink-0 mt-1" />
                    <div>
                      <h3 className="font-bold text-lg text-green-900 mb-2">
                        Regelmäßige Desinfektion
                      </h3>
                      <p className="text-green-800">
                        {hygienInfo.regularDisinfection}. Ihre Sicherheit und die Gesundheit Ihres Tieres 
                        stehen bei uns an erster Stelle.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Infectious Animals Transport */}
                <div className="bg-orange-50 border-2 border-orange-200 rounded-xl p-6">
                  <div className="flex items-start space-x-3">
                    <AlertCircle className="h-6 w-6 text-orange-600 flex-shrink-0 mt-1" />
                    <div className="space-y-4">
                      <div>
                        <h3 className="font-bold text-lg text-orange-900 mb-2">
                          Transport von infektiösen Tieren
                        </h3>
                        <p className="text-orange-800 mb-3">
                          <strong>{hygienInfo.infectiousTransport.condition}</strong> ist auch der Transport 
                          von Tieren mit Infektionskrankheiten möglich.
                        </p>
                      </div>

                      <div className="bg-white rounded-lg p-4 border border-orange-300">
                        <h4 className="font-semibold text-orange-900 mb-2 flex items-center">
                          <span className="bg-orange-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-sm mr-2">
                            €
                          </span>
                          Zusatzkosten: {hygienInfo.infectiousTransport.cost}€
                        </h4>
                        <p className="text-sm text-gray-700 mb-3">
                          <strong>Grund:</strong> {hygienInfo.infectiousTransport.reason}
                        </p>
                        
                        <h4 className="font-semibold text-orange-900 mb-2 text-sm">
                          Diese Kosten fallen an bei:
                        </h4>
                        <ul className="space-y-2">
                          {hygienInfo.infectiousTransport.triggers.map((trigger, index) => (
                            <li key={index} className="flex items-start text-sm text-gray-700">
                              <span className="text-orange-600 mr-2 flex-shrink-0">•</span>
                              <span>{trigger}</span>
                            </li>
                          ))}
                        </ul>
                      </div>

                      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                        <p className="text-sm text-blue-800">
                          <strong>Hinweis:</strong> Bitte informieren Sie uns vorab, wenn Ihr Tier 
                          bekanntermaßen an einer Infektionskrankheit leidet. Dies ermöglicht uns eine 
                          optimale Vorbereitung und schützt andere Tiere.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Additional Info */}
                <div className="text-center pt-4 border-t">
                  <p className="text-sm text-gray-600">
                    Bei Fragen zur Hygiene oder zum Transport infektiöser Tiere kontaktieren Sie uns bitte 
                    unter <strong>01573 969 69 42</strong>
                  </p>
                </div>

                <Button
                  onClick={() => setIsOpen(false)}
                  className="w-full h-12 bg-gradient-to-r from-green-600 to-blue-600 hover:from-green-700 hover:to-blue-700"
                >
                  Verstanden
                </Button>
              </CardContent>
            </Card>
          </div>
        </div>
      )}
    </>
  );
};

export default HygieneInfo;
